import { computed, } from 'vue'
import { genHeadOverrides, } from '@/assets/js/src/layout/meta'
import { useStripHtml, } from '@/assets/js/src/util/composables/useStripHtml'
import { useHead, } from '@unhead/vue'

export const useItemHeadInfo = ({ asyncStatusLoaded,helpItem, }) => {
    const { stripHtml, } = useStripHtml()

    const title = computed(() => {
        return asyncStatusLoaded.value ? helpItem.value.title : 'Help'
    })

    const description = computed(() => {
        if (typeof helpItem.value.message !== 'undefined' && asyncStatusLoaded.value) {
            let content = stripHtml(helpItem.value.message)

            return `${content.replace(/^(.{100}[^\s]*).*/, '$1')} ...`
        }

        return ''
    })

    useHead(genHeadOverrides({ title, description, }))

    return {
        description,
    }
}
